import type { Control, FieldValues, Path } from 'react-hook-form';
import { FormControl, FormField, FormItem, FormMessage } from 'shared/ui/form';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from 'shared/ui/select';
import * as React from 'react';
import { TariffSelectorSkeleton } from 'features/change-tariff/ui/tariff-selector skeleton';
import * as m from '@paraglide/messages';
import type { Tariff } from '../modal';
export interface TariffSelectorProps<TData extends FieldValues = FieldValues> {
  name: Path<TData>;
  control: Control<TData> | undefined;
  tariffsData: Tariff[];
  isLoading: boolean;
  disabled?: boolean;
}
export const TariffSelector = <TData extends FieldValues = FieldValues,>({
  name,
  control,
  tariffsData,
  isLoading,
  disabled = false
}: TariffSelectorProps<TData>) => {
  const changeTariff = (tariffId: string, fieldChange: (tariffId: string) => void) => {
    if (!tariffId) return;
    fieldChange(tariffId);
  };
  if (isLoading) return <TariffSelectorSkeleton />;
  return <div className="flex-2 w-full" data-sentry-component="TariffSelector" data-sentry-source-file="tariff-selector.tsx">
      <FormField name={name} control={control} rules={{
      maxLength: 12,
      required: m.required_field()
    }} render={({
      field
    }) => <FormItem className="flex flex-col">
            <Select onValueChange={value => changeTariff(value, field.onChange)} value={field.value?.toString()} disabled={disabled}>
              <FormControl>
                <SelectTrigger>
                  <SelectValue placeholder={m.tab_tariff_field_plan_placeholder()} />
                </SelectTrigger>
              </FormControl>
              <SelectContent>
                {tariffsData.map(tariff => <SelectItem key={tariff.id} value={tariff.id.toString()}>
                    {tariff.name}
                  </SelectItem>)}
              </SelectContent>
            </Select>
            <FormMessage />
            <p className="pl-4 text-caption leading-4 text-muted-foreground mt-2">
              {tariffsData.find(tariff => tariff.id === +(field?.value ?? 0))?.description ?? null}
            </p>
          </FormItem>} data-sentry-element="FormField" data-sentry-source-file="tariff-selector.tsx" />
    </div>;
};